/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import ReactCrop from 'react-image-crop';
import { Spin } from 'antd';

import { initCrop, scaleCrop } from './utils';

import s from './styles.module.less';
import 'react-image-crop/dist/ReactCrop.css';

const ImageCropper = ({ initialCrop, initialAspect, unit, onImageLoaded, onComplete, onChange, ...props }) => {
  const [loading, setLoading] = React.useState(true);
  const imageRef = React.useRef(null);
  const [crop, setCrop] = React.useState({});

  const handleOnImageLoaded = React.useCallback(
    (image) => {
      setCrop(initCrop({ image, initialCrop, initialAspect, unit }));
      imageRef.current = image;

      // eslint-disable-next-line no-unused-expressions
      onImageLoaded?.(image);
      setLoading(false);
      return false;
    },
    [initialAspect, initialCrop, onImageLoaded, unit],
  );

  const handleComplete = React.useCallback(
    (newCrop) => {
      const scaledNewCrop = scaleCrop({ crop: newCrop, image: imageRef.current });
      // eslint-disable-next-line no-unused-expressions
      onComplete?.(scaledNewCrop, newCrop);
    },
    [onComplete],
  );

  const handleOnChange = React.useCallback(
    (_crop) => {
      setCrop(_crop);
      // eslint-disable-next-line no-unused-expressions
      onChange?.(_crop);
    },
    [onChange],
  );

  return (
    <Spin spinning={loading} wrapperClassName={s.root}>
      <ReactCrop
        crop={crop}
        onChange={handleOnChange}
        onImageLoaded={handleOnImageLoaded}
        onComplete={handleComplete}
        className={s.crop}
        {...props}
      />
    </Spin>
  );
};

export default ImageCropper;
